import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { SessionService } from "../../core/services/session.service";
import { EtapasBeneficioComponent } from "../../shared/components/etapas-beneficio/etapas-beneficio.component";
import { BeneficiaryService } from "../../core/services/beneficiary.service";

@Component({
  selector: 'app-dados-pessoais',
  standalone: true,
  imports: [
    MatCardModule,
    EtapasBeneficioComponent,
    CommonModule
  ],
  templateUrl: './dados-pessoais.component.html',
  styleUrl: './dados-pessoais.component.scss'
})
export class DadosPessoaisComponent implements OnInit {

  beneficiario: any= '';

  beneficiarioPagina: any= '';

  constructor(private sessionService: SessionService, private beneficiarioService: BeneficiaryService) {}

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario
    this.beneficiarioService.getDadosPessoais(this.beneficiario.matricula,this.beneficiario.orgao.id).subscribe({
      next: (res: any) => {
        console.log(res)
        this.beneficiarioPagina = res
      },
      error: (err: any) => {
        console.error('Erro ao enviar', err)
      }
    })
  }



}
